import types, { ActionCreators } from './types';

const limitComponentERR: ActionCreators['LimitComponentERR'] = (
  limitType,
  errorMessages,
  error,
) => ({
  type: types.LIMIT_COMPONENT_ERR,
  limitType,
  errorMessages,
  error,
});

const limitComponentOK: ActionCreators['LimitComponentOK'] = (limitType, id) => ({
  type: types.LIMIT_COMPONENT_OK,
  limitType,
  id,
});

const limitComponentsERR: ActionCreators['LimitComponentsERR'] = (errorMessages, error) => ({
  type: types.LIMIT_COMPONENTS_ERR,
  errorMessages,
  error,
});

const limitComponentsOK: ActionCreators['LimitComponentsOK'] = () => ({
  type: types.LIMIT_COMPONENTS_OK,
});

const limitToggleUpdate: ActionCreators['LimitToggleUpdate'] = (configKey) => ({
  type: types.LIMIT_TOGGLE_UPDATE,
  limitConfigurationKey: configKey,
});

const limitConfigurationUpdate: ActionCreators['LimitConfigurationUpdate'] = (
  limitConfigurationKey,
  key,
  value,
) => ({
  type: types.LIMIT_CONFIGURATION_UPDATE,
  limitConfigurationKey,
  key,
  value,
});

const requestLimit: ActionCreators['RequestLimit'] = (id, limitType) => ({
  type: types.REQUEST_LIMIT,
  id,
  limitType,
});

const requestLimitERR: ActionCreators['RequestLimitERR'] = (errorMessages, error) => ({
  type: types.REQUEST_LIMIT_ERR,
  errorMessages,
  error,
});

const requestLimitOK: ActionCreators['RequestLimitOK'] = (selectedLimit) => ({
  type: types.REQUEST_LIMIT_OK,
  selectedLimit,
});

const requestLimitsOK: ActionCreators['RequestLimitsOK'] = () => ({
  type: types.REQUEST_LIMITS_OK,
});

const resetInitialLimitsState: ActionCreators['ResetInitialLimitsState'] = (limits) => ({
  type: types.RESET_INITIAL_LIMITS_STATE,
  limits,
});

const actions = {
  limitComponentERR,
  limitComponentOK,
  limitComponentsERR,
  limitComponentsOK,
  limitToggleUpdate,
  limitConfigurationUpdate,
  requestLimit,
  requestLimitERR,
  requestLimitOK,
  requestLimitsOK,
  resetInitialLimitsState,
};
export default actions;
